import React, { useCallback, useState, useContext, useEffect } from 'react';
import BaseSectionContainer from '../containers/baseSectionContainer';
import GroupUpdateSection from '../sections/group';
import MemberGroup from '../sections/memberGroup';
import { UserGroupContext } from '../../Licensing/userSetup';

interface Props {
  tableContainerStyle?: React.CSSProperties;
  setSelectedGroups: React.Dispatch<React.SetStateAction<any[]>>;
  selectedGroups: any[];
  setEditId: React.Dispatch<React.SetStateAction<number>>;
  editId: number;
}

const GroupSection = (props: Props) => {
  const { tableContainerStyle, setSelectedGroups, selectedGroups, editId, setEditId } = props;
  const { tempState } = useContext(UserGroupContext);
  const onSelectedGroupChange = useCallback(
    (groupIndices) =>
      setSelectedGroups(tempState.groups.filter((_v, _ix) => groupIndices.includes(_ix))),
    [setSelectedGroups, tempState],
  );

  const updateSelectedGroups = useCallback(() => {
    setSelectedGroups((prv) => {
      const _groupIds = prv.map((g) => g.id);

      return tempState.groups?.filter((g) => _groupIds.includes(g.id)) || [];
    });
  }, [tempState]);

  useEffect(() => updateSelectedGroups(), [tempState]);

  return (
    <BaseSectionContainer
      firstSection={
        <GroupUpdateSection
          onSelectedGroupChange={onSelectedGroupChange}
          selectedGroups={selectedGroups}
          setSelectedGroups={setSelectedGroups}
          tableContainerStyle={tableContainerStyle}
          editId={editId}
          setEditId={setEditId}

        />
      }
      secondSection={
        <MemberGroup
          selectedGroup={selectedGroups.length > 1 ? null : selectedGroups[0]}
        />
      }
    />
  );
};

export default GroupSection;
